export class ARMiscInvoiceTypeResultDto {
    miscInvoiceTypeId: number;
    miscInvoiceTypeText: string;
    category: string;
    defaultDescription: string;
    isPayableToManagementCompany: boolean;
    defaultFee: number;
    userCanOverrideFee: boolean;

    defaultSubLedgerId: number;
    accountLabelHasDefaultSubLedger: boolean;
}
